import React, { useState, useRef, useEffect } from "react";
import { Signup } from "../../../redux/actions/Auth";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SocialAuthOptions from "./Login/SocialAuthOptions";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import Recaptcha from "react-google-recaptcha";
import Toast from "wrappers/Toast";
import Loader from "assets/animated-images/Loader";
import Axios from "api/Api";
import { State, City } from "country-state-city";
import {
  emailRegex,
  partnerId,
  phoneNumberRegex,
  REACT_APP_SITE_KEY,
} from "api/Consts";
import partnerData from "../../../partnerData.json";
const COUNTRY_CODE = "IN";
const COKE_REFERRER = "cokecait.skillstrainer.in";
const COKE_PARTNER_ID = 88;

const OtpSection = ({
  otpStep,
  OTP_STEP,
  input,
  otpValue,
  setOtpValue,
  handleVerifyOtp,
  handleSendOtp,
  resendTimer,
  otpLoading,
}) => {
  if (otpStep === OTP_STEP.VERIFIED) {
    return (
      <div className="flex items-center gap-2 mb-4 px-3 py-2 bg-green-50 border border-green-300 rounded-md">
        <span className="text-green-600 font-semibold text-sm">
          ✓ Mobile number verified
        </span>
      </div>
    );
  }

  if (otpStep === OTP_STEP.OTP_SENT) {
    return (
      <div className="mb-6">
        <label className="block tracking-wide text-japanese_indigo text-xs mb-2">
          Enter OTP sent to {input.id}
        </label>

        <div className="flex gap-2">
          <input
            className="input flex-1"
            type="tel"
            inputMode="numeric"
            placeholder="6-digit OTP"
            maxLength={6}
            value={otpValue}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, "").slice(0, 6);
              setOtpValue(val);
            }}
          />

          <button
            type="button"
            onClick={handleVerifyOtp}
            disabled={otpLoading}
            className="px-4 py-2 bg-orange text-white rounded-md font-semibold text-sm whitespace-nowrap"
          >
            {otpLoading ? "Verifying..." : "Verify OTP"}
          </button>
        </div>

        <div className="mt-2 text-xs text-gray-500">
          {resendTimer > 0 ? (
            <span>Resend OTP in {resendTimer}s</span>
          ) : (
            <button
              type="button"
              onClick={handleSendOtp}
              className="text-orange underline"
              disabled={otpLoading}
            >
              {otpLoading ? "Sending..." : "Resend OTP"}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 px-3">
      <button
        type="button"
        onClick={handleSendOtp}
        disabled={otpLoading}
        className="w-full py-2 border-2 border-orange text-orange font-semibold rounded-md text-sm"
      >
        {otpLoading ? "Sending OTP..." : "Send OTP to verify mobile"}
      </button>

      <p className="text-xs text-gray-400 mt-1 text-center">
        OTP will be sent to your mobile number
      </p>
    </div>
  );
};

const SignUpComponent = (props) => {
  console.log("ptrops", props);
  console.log("partnerIDD", partnerId, partnerData);
  const isCoke = document.referrer.includes(COKE_REFERRER);
  console.log("isCokee", isCoke);
  const authCourseId = useSelector(({ auth }) => auth.courseId);
  console.log("authCourseIdd", authCourseId);
  const useCokeSignupFlow = isCoke || Number(authCourseId) === 302;
  const onChange = (value) => {
    let captcha_token = value;
    setInput({ ...input, captcha_token });
  };
  const OTP_STEP = { FORM: "FORM", OTP_SENT: "OTP_SENT", VERIFIED: "VERIFIED" };
  const [otpStep, setOtpStep] = useState(OTP_STEP.FORM);
  const [otpValue, setOtpValue] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [loaderOn, setLoaderOn] = useState(false);
  const [input, setInput] = useState({
    full_name: "",
    id: "",
    password: "",
    coupon_code: "",
    captcha_token: "",
    date_of_birth: "",
    state: "",
    district: "",
    referrer: document.referrer,
  });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedStateIso, setSelectedStateIso] = useState("");
  const [passWordErrorText, setPassWordErrorText] = useState("");
  useEffect(() => {
    if (useCokeSignupFlow) {
      setStateList(State.getStatesOfCountry(COUNTRY_CODE));
    }
  }, [useCokeSignupFlow]);

  useEffect(() => {
    if (!selectedStateIso) {
      setDistrictList([]);
      return;
    }
    const cities = City.getCitiesOfState(COUNTRY_CODE, selectedStateIso);
    setDistrictList(cities);
  }, [selectedStateIso]);

  useEffect(() => {
    if (resendTimer <= 0) return;
    const t = setTimeout(() => setResendTimer((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [resendTimer]);
  const onInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "password") {
      const re = /^[\S]{5,30}$/;
      if (!re.test(value)) {
        setPassWordErrorText(
          "Password length should be min 5 characters and max 30 without any spaces",
        );
      } else {
        setInput((prev) => ({ ...prev, [name]: value }));
        setPassWordErrorText("");
      }
      return;
    }

    if (name === "state") {
      const stateObj = stateList.find((s) => s.isoCode === value);
      setSelectedStateIso(value);
      setInput((prev) => ({
        ...prev,
        state: stateObj ? stateObj.name : "",
        district: "",
      }));
      return;
    }

    setInput((prev) => ({ ...prev, [name]: value }));
  };
  const handleSendOtp = async () => {
    if (!phoneNumberRegex.test(input.id)) {
      Toast.error("Please enter a valid 10-digit mobile number");
      return;
    }
    if (!input.full_name.trim()) {
      Toast.error("Please enter your full name first");
      return;
    }
    if (!input.state) {
      Toast.error("Please select a State first");
      return;
    }
    if (!input.district) {
      Toast.error("Please select a District first");
      return;
    }

    setOtpLoading(true);
    try {
      const res = await Axios.post("/send_otp", {
        mobile_number: input.id,
        partner_id: COKE_PARTNER_ID,
      }).then(({ data }) => data);

      if (res.success) {
        Toast.success("OTP sent to your mobile number");
        setOtpStep(OTP_STEP.OTP_SENT);
        setResendTimer(30);
      } else {
        Toast.error(res.message || "Failed to send OTP");
      }
    } catch {
      Toast.error("Failed to send OTP. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };
  console.log("otpvalue", otpValue);
  const handleVerifyOtp = async () => {
    if (!otpValue || otpValue.length !== 6) {
      Toast.error("Please enter the 6-digit OTP");
      return;
    }
    setOtpLoading(true);
    try {
      const res = await Axios.post("/verify_otp", {
        mobile_number: input.id,
        otp: String(otpValue),
      }).then(({ data }) => data);

      if (res.success) {
        Toast.success("Mobile number verified!");
        setOtpStep(OTP_STEP.VERIFIED);
      } else {
        Toast.error(res.message || "Invalid OTP");
      }
    } catch {
      Toast.error("OTP verification failed. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  const StateDistrictFields = () => (
    <div className="flex flex-wrap -mx-3">
      {/* State */}
      <div className="w-full px-3 sm:w-1/2 mb-6">
        <label
          className="block tracking-wide text-japanese_indigo text-xs mb-2"
          htmlFor="grid-state"
        >
          State *
        </label>
        <select
          className="input"
          id="grid-state"
          name="state"
          value={selectedStateIso}
          onChange={onInputChange}
        >
          <option value="">Select State</option>
          {stateList.map((s) => (
            <option key={s.isoCode} value={s.isoCode}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      {/* District */}
      <div className="w-full px-3 sm:w-1/2 mb-6">
        <label
          className="block tracking-wide text-japanese_indigo text-xs mb-2"
          htmlFor="grid-district"
        >
          District *
        </label>
        <select
          className="input"
          id="grid-district"
          name="district"
          value={input.district}
          onChange={onInputChange}
          disabled={!selectedStateIso}
        >
          <option value="">
            {selectedStateIso ? "Select District" : "Select State first"}
          </option>
          {districtList.map((d) => (
            <option key={d.name} value={d.name}>
              {d.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
  const [showPassword, setShowPassword] = useState(false);
  const error = useSelector(({ auth }) => auth.signup_error);
  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (useCokeSignupFlow) {
      if (!phoneNumberRegex.test(input.id)) {
        Toast.error("Please enter a valid mobile number");
        return;
      }
      if (otpStep !== OTP_STEP.VERIFIED) {
        Toast.error("Please verify your mobile number with OTP first");
        return;
      }
      if (!input.state) {
        Toast.error("Please select a State");
        return;
      }
      if (!input.district) {
        Toast.error("Please select a District");
        return;
      }
    } else {
      if (!emailRegex.test(input.id) && !phoneNumberRegex.test(input.id)) {
        Toast.error("Invalid Email or Phone Number");
        return;
      }
    }

    setLoaderOn(true);

    /*
     *
     *
     * Checking and confirming force create
     *
     *
     */
    let loader = Toast.load("Please wait...");
    const email =
      emailRegex.test(input.id.toLowerCase()) && input.id.toLowerCase();
    const mobile_number = phoneNumberRegex.test(input.id) && input.id;

    const traineeSearchResponse = await Axios.post("/search_trainees", {
      email,
      mobile_number,
    }).then(({ data }) => data);
    const { data: duplicateTrainees } = traineeSearchResponse;
    Toast.endLoader(loader);

    if (duplicateTrainees?.length) {
      if (useCokeSignupFlow) {
        await Toast.confirm(
          <div>
            <p>
              User with this mobile number already exists. Please register with
              a different phone number.
            </p>
          </div>,
        );
        return;
      }
      const forceCreate = await Toast.confirm(
        <DuplicateTraineesMessage duplicateTrainees={duplicateTrainees} />,
      );
      if (!forceCreate) return;
    }

    /*
     *
     *
     * Registering user
     *
     *
     */

    console.log("input", input);

    if (emailRegex.test(input.id) || phoneNumberRegex.test(input.id)) {
      dispatch(Signup({ ...input })).then(() => {
        setLoaderOn(false);
      });
    } else {
      Toast.error("Invalid Email or Phone Number");
      setLoaderOn(false);
    }
  };

  return (
    <div className="col-span-3 md:col-span-1 bg-white sw-full rounded-lg z-1">
      {props.courseId && props.courseId === "1" ? (
        <div>
          <h1 className="text-2xl font-semibold text-japanese_indigo">
            Register For
          </h1>
          {props.notice && (
            <div className="w-full text-center px-4 py-2 rounded-md bg-yellow-100 text-orange-500 mt-3">
              {props.notice}
            </div>
          )}
          <p className="text-xs my-5 text-gray-600">
            Already have an account?&nbsp;
            <Link to="/login" className="text-orange">
              Login
            </Link>
          </p>
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full  px-3 mb-6">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-full-name"
                >
                  Full Name*
                </label>
                <input
                  className="input"
                  id="grid-full-name"
                  type="text"
                  placeholder="Your Full Name"
                  name="full_name"
                  onChange={onInputChange}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full px-3 sm:w-1/2 mb-6">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-id"
                >
                  Email or Phone number *
                </label>
                <input
                  className="input"
                  id="grid-id"
                  type="text"
                  placeholder="Your Email or Phone Number"
                  name="id"
                  data-key="password"
                  onChange={onInputChange}
                />
              </div>
              <div className="w-full px-3 sm:w-1/2 mb-6 relative">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-password"
                >
                  Password
                </label>
                {showPassword ? (
                  <BsEye
                    onClick={() => setShowPassword(false)}
                    className="absolute mt-4 right-6 opacity-60"
                  />
                ) : (
                  <BsEyeSlash
                    onClick={() => setShowPassword(true)}
                    className="absolute mt-4 right-6 opacity-60"
                  />
                )}

                <input
                  className="input"
                  id="grid-password"
                  type={showPassword ? "text" : "password"}
                  placeholder="********"
                  name="password"
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full px-3">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-password"
                >
                  SkillsTrainer Coupon (If any)
                </label>
                <input
                  className="input"
                  type="text"
                  placeholder="Skillstrainer Coupon"
                  name="coupon_code"
                  onChange={onInputChange}
                />
              </div>
            </div>
            {error && <h2 className="text-orange">{error}</h2>}
            {passWordErrorText.length > 0 && (
              <h2 className="text-orange">{passWordErrorText}</h2>
            )}
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <button
                  className="w-full mt-4 font-semibold bg-orange text-white rounded-md p-2 text-lg"
                  type="submit"
                >
                  {!loaderOn ? (
                    <div className="h-8">Create an account</div>
                  ) : (
                    <Loader color="#fff" className="h-8 mx-auto" />
                  )}
                </button>
              </div>
            </div>
          </form>
          <SocialAuthOptions />
          <Recaptcha
            sitekey={REACT_APP_SITE_KEY}
            onChange={onChange}
            className="g-recaptcha mt-6"
            name="captcha_token"
          />
        </div>
      ) : (
        <div>
          <h1 className="text-2xl font-semibold text-japanese_indigo pt-5">
            Sign Up
          </h1>
          {props.notice && (
            <div className="w-full text-center px-4 py-2 rounded-md bg-yellow-100 text-orange-500 mt-3">
              {props.notice}
            </div>
          )}
          <p className="text-xs my-5 text-gray-600">
            Already have an account?&nbsp;
            <Link to="/login" className="text-orange">
              Login
            </Link>
          </p>
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full  px-3 mb-6">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-full-name"
                >
                  Full Name*
                </label>
                <input
                  className="input"
                  id="grid-full-name"
                  type="text"
                  placeholder="Your Full Name"
                  name="full_name"
                  onChange={onInputChange}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full  px-3 mb-6">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-full-name"
                >
                  Date Of Birth*
                </label>
                <input
                  className="input"
                  id="grid-full-name"
                  type="date"
                  placeholder="Your Date Of Birth"
                  name="date_of_birth"
                  onChange={onInputChange}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full px-3 sm:w-1/2 mb-6">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-id"
                >
                  {useCokeSignupFlow
                    ? "Mobile Number *"
                    : "Email or Phone number *"}
                </label>
                <input
                  className="input"
                  id="grid-id"
                  type={useCokeSignupFlow ? "tel" : "text"}
                  placeholder={
                    useCokeSignupFlow
                      ? "Your Mobile Number"
                      : "Your Email or Phone Number"
                  }
                  name="id"
                  data-key="password"
                  disabled={useCokeSignupFlow && otpStep !== OTP_STEP.FORM}
                  onChange={onInputChange}
                />
              </div>
              <div className="w-full px-3 sm:w-1/2 mb-6 relative">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-password"
                >
                  Password
                </label>
                {showPassword ? (
                  <BsEye
                    onClick={() => setShowPassword(false)}
                    className="absolute mt-4 right-6 opacity-60"
                  />
                ) : (
                  <BsEyeSlash
                    onClick={() => setShowPassword(true)}
                    className="absolute mt-4 right-6 opacity-60"
                  />
                )}

                <input
                  className="input"
                  id="grid-password"
                  type={showPassword ? "text" : "password"}
                  placeholder="********"
                  name="password"
                  onChange={onInputChange}
                />
              </div>
            </div>
            {useCokeSignupFlow && <StateDistrictFields />}
            {useCokeSignupFlow && (
              <OtpSection
                otpStep={otpStep}
                OTP_STEP={OTP_STEP}
                input={input}
                otpValue={otpValue}
                setOtpValue={setOtpValue}
                handleVerifyOtp={handleVerifyOtp}
                handleSendOtp={handleSendOtp}
                resendTimer={resendTimer}
                otpLoading={otpLoading}
              />
            )}
            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full px-3">
                <label
                  className="block tracking-wide text-japanese_indigo text-xs mb-2"
                  htmlFor="grid-password"
                >
                  SkillsTrainer Coupon (If any)
                </label>
                <input
                  className="input"
                  type="text"
                  placeholder="Skillstrainer Coupon"
                  name="coupon_code"
                  onChange={onInputChange}
                />
              </div>
            </div>
            {error && <h2 className="text-orange">{error}</h2>}
            {passWordErrorText.length > 0 && (
              <h2 className="text-orange">{passWordErrorText}</h2>
            )}
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <button
                  className="w-full mt-4 font-semibold bg-orange text-white rounded-md p-2 text-lg disabled:opacity-50"
                  type="submit"
                  disabled={useCokeSignupFlow && otpStep !== OTP_STEP.VERIFIED}
                  title={
                    useCokeSignupFlow && otpStep !== OTP_STEP.VERIFIED
                      ? "Please verify mobile number first"
                      : ""
                  }
                >
                  {!loaderOn ? (
                    <div className="h-8">Create an account</div>
                  ) : (
                    <Loader color="#fff" className="h-8 mx-auto" />
                  )}
                </button>
                {useCokeSignupFlow && otpStep !== OTP_STEP.VERIFIED && (
                  <p className="text-xs text-center text-gray-400 mt-1">
                    Verify your mobile number to enable signup
                  </p>
                )}
              </div>
            </div>
          </form>
          {!useCokeSignupFlow && (
            <>
              {" "}
              <SocialAuthOptions />
              <Recaptcha
                sitekey={REACT_APP_SITE_KEY}
                onChange={onChange}
                className="g-recaptcha mt-6"
                name="captcha_token"
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SignUpComponent;

const DuplicateTraineesMessage = ({ duplicateTrainees }) => (
  <div>
    <p>We have found trainees with the same email / phone number:</p>
    <ul>
      {duplicateTrainees.map((dt) => (
        <li key={dt.username}>
          <span className="font-semibold">{dt.name.familyName}</span> (
          {dt.username})
        </li>
      ))}
    </ul>

    <p>Force create a new user?</p>
  </div>
);
